module.exports = __webpack_public_path__ + "img/help-newboard.7d2aa2fa.png";